module.exports = __webpack_public_path__ + "img/consulta-ja-logo2.5e993e86.png";